import { createFileRoute, redirect } from "@tanstack/react-router";
import { createAuthApi } from "../shell-handle/auth";

export const Route = createFileRoute("/logout")({
  beforeLoad: async () => {
    try {
      await createAuthApi().signOut();
    } catch {
      /* ignore */
    }
    throw redirect({ to: "/login" });
  },
  component: () => null,
});
